import React from 'react';

import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';

import FieldHistoryBody from './FieldHistoryBody';
import type { FieldHistoryEntry } from './types';

interface Props {
  chipLabel?: string;
  emptyMessage?: string;
  entries: Array<FieldHistoryEntry>;
  error?: Error | null;
  isLoading?: boolean;
  // When set, "View all" calls this to open the full report
  onViewAll?: () => void;
  title?: string;
  totalCount?: number;
}

export default function FieldHistoryPanel({
  chipLabel,
  emptyMessage,
  entries,
  error,
  isLoading,
  onViewAll,
  title = 'History',
  totalCount = entries.length,
}: Props) {
  const viewAllLabel = totalCount > entries.length ? `View all (${totalCount})` : 'View all';

  return (
    <Paper variant="outlined">
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 3, py: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Typography variant="h6">{title}</Typography>
          {chipLabel && <Chip color="primary" label={chipLabel} size="small" variant="outlined" />}
        </Stack>
        {onViewAll && entries.length > 0 && (
          <Button variant="text" onClick={onViewAll}>
            {viewAllLabel}
          </Button>
        )}
      </Stack>
      <Box sx={{ borderTop: 1, borderColor: 'divider' }}>
        <FieldHistoryBody emptyMessage={emptyMessage} entries={entries} error={error} isLoading={isLoading} />
      </Box>
    </Paper>
  );
}
